module.exports = __webpack_public_path__ + "img/02.985c7658.jpg";